export interface SortType {
  type: string
  key: string
}

export const SortOptions = [
  {
    type: 'Distance closest first',
    key: 'distance;asc'
  },
  {
    type: 'Distance furthest first',
    key: 'distance;desc'
  }
]
